import styled from "styled-components";

export const Container = styled.div`
	grid-area: "MN";

	display: flex;
	flex-direction: column;
	gap: 40px;
	max-height: calc(100vh - 20px);
	overflow-y: scroll;

	.publish-button {
		background-color: var(--main-blue);
		border: 2px solid var(--main-blue);
		width: 260px;
		padding: 10px;
		font-size: 18px;
		color: white;
		border-radius: 10px;
		float: right;
		transition: 300ms ease-in-out;
	}
	.publish-button:hover {
		background-color: var(--dark-blue);
		scale: 1.01;
		border-color: var(--darkest-blue);
	}

	.top {
		display: flex;
		flex-direction: column;
		gap: 40px;

		h1 {
			font-size: 32px;
		}

		input,
		textarea,
		label {
			width: 400px;
			min-height: 40px;
			padding: 10px;
			border-radius: 10px;
			border: 2px solid var(--dark-green);
		}

		input:active,
		textarea:active {
			border-color: var(--ligth-green);
		}

		#description {
			align-self: center;
			width: 800px;
			height: 250px;
		}

		.banner-define {
			display: flex;
			justify-content: space-between;

			.info {
				display: flex;
				flex-direction: column;
				gap: 15px;

				.textarea-wrapper {
					display: flex;
					flex-direction: column;
					gap: 5px;
					p {
						font-size: 12px;
						align-self: flex-end;
						font-style: italic;
						font-weight: 500;
					}
				}

				textarea {
					height: 150px;
					padding: 10px;
					font-size: 14px;
				}

				.upload-button {
					display: flex;
					flex-direction: column;
					justify-content: space-between;
					gap: 40px;
					margin-top: 5px;

					span {
						margin-top: 20px;
						color: rgb(148, 148, 148);
						font-size: 12px;
						text-align: center;
					}

					p {
						display: flex;
						color: rgb(148, 148, 148);
						gap: 20px;
						align-items: center;
						justify-content: center;
					}
					#secondary {
						font-size: 12px;
					}

					display: inline-block;
					border: 2px dashed var(--very_light-green);
					color: white;
					font-size: 16px;
					cursor: pointer;
					transition: border-color 600ms;
					transition: background-color 600ms;
				}
				.upload-button input[type="file"] {
					display: none;
				}

				.upload-button:hover {
					border-color: var(--dark-green);
					background-color: rgb(196, 202, 192);
				}
			}
		}
	}

	.banner-preview {
		h2 {
			font-size: 24px;
			margin-bottom: 10px;
		}
	}

	.articles-wrapper {
		h2 {
			font-size: 27px;
		}
		.empty {
			color: gray;
		}

		ul {
			li {
				list-style: decimal;
			}
		}

		button.add {
			margin: 30px 0;
			background-color: var(--dark-green);
			color: white;
			padding: 10px 20px;
			border-radius: 10px;
			transition: background-color 300ms ease-in-out;
		}
		button.add:hover {
			background-color: var(--main-green);
		}
		.addArticles-wrapper {
			display: none;
		}

		.visible {
			display: flex;
			justify-content: space-between;
		}

		.types-wrapper {
			display: flex;
			flex-direction: column;
			gap: 5px;

			button {
				width: 250px;
				align-self: flex-start;
				padding: 5px 0;
				border: 2px solid var(--very_light-green);
				border-radius: 10px;
				transition: background-color 300ms ease-in-out;
			}
			button:hover {
				background-color: var(--main-green);
			}
		}

		.infoAdd-area {
			display: flex;
			flex-direction: column;
		}

		.actionButtons-wrapper {
			display: flex;
			gap: 20px;
			align-items: center;
			justify-content: center;

			#cancel {
				background-color: #792134;
				padding: 10px 20px;
				border-radius: 10px;
				color: white;
				transition: background-color 300ms ease-in-out;
				justify-self: flex-start;
			}
			#cancel:hover {
				background-color: #f5446a;
			}

			.buttonfalse {
				display: none;
			}
		}
	}
`;

export const NoticeBlock = styled.div`
	width: 600px;
	height: 288px;
	border-radius: 8px;

	.notice-btn {
		border-radius: 8px;
		height: 288px;
		display: flex;
		align-items: center;
		justify-content: space-between;
		color: black;

		transition: 500ms;

		-webkit-box-shadow: -1px -2px 24px -7px rgba(0, 0, 0, 0.75);
		-moz-box-shadow: -1px -2px 24px -7px rgba(0, 0, 0, 0.75);
		box-shadow: -1px -2px 24px -7px rgba(0, 0, 0, 0.75);

		img,
		.imageShadow {
			background-color: gray;
			width: 180px;
			border-radius: 8px 0 0 8px;
			transition: 500ms;
			height: 100%;
		}
		.content {
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: space-between;
			width: calc(100% - 180px - 5px);

			h2 {
				white-space: nowrap;
				max-width: 100%;
				overflow: hidden;
				text-overflow: ellipsis;
				font-size: 28px;
				font-weight: 700;
			}

			.desc {
				height: calc(257px - 20px - 30px);
				display: flex;
				flex-direction: column;
				width: 100%;
				padding: 10px;
				gap: 20px;
				p {
					text-align: left;
					display: -webkit-box;
					-webkit-line-clamp: 7;
					-webkit-box-orient: vertical;
					overflow: hidden;
					height: 140px;
				}
				.desc-btn {
					color: var(--main-green);
					font-weight: 700;
				}
			}
		}
	}

	.notice-btn:hover {
		scale: 1.02;
		border: 2px solid var(--light-green);
		img {
			margin-left: -2px;
		}
	}
`;

export const Wrapper = styled.div`
	max-width: 1100px;
	width: 100vw;
	margin: 0 auto;
`;
